import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import { ConfirmationDialogService } from 'src/app/shared/confirmation-dialog/confirmation-dialog.service';
import { HttpService } from 'src/app/shared/http.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private _router: Router) { }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (localStorage.getItem('currentUser')) {
      return true;
    }
    this._router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
}

@Injectable({ providedIn: 'root' })
export class CanDeactivateGuard implements CanDeactivate<FormComponent> {

  constructor(private confirmationDialogService: ConfirmationDialogService) { }

  canDeactivate(component: any) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    if (component.form && component.form.dirty && component.confirmationDialogService.isIdle == false&& component.confirmationDialogService.isSkip==false ) {
      return component.form.dirty ? currentUser ? component.confirmationDialogService
        .confirm('Warning - Unsaved Changes',
          '<p>You have made changes to this page which have not been saved!</p><p>Are you sure you want to leave this page?</p>',
          'Leave Page')
        .then((confirmed: any) => {
          if (confirmed === true) {
            return true;
          }
          else {
            return false;
          }
        }) : true : true;
    }

    if (component.duelForm && component.confirmationDialogService.isIdle == false) {
      return component.duelForm.dirty ? currentUser ? component.confirmationDialogService
        .confirm('Warning - Unsaved Changes',
          '<p>You have made changes to this page which have not been saved!</p><p>Are you sure you want to leave this page?</p>',
          'Leave Page')
        .then((confirmed: any) => {
          if (confirmed === true) {
            return true;
          }
          else {
            return false;
          }
        }) : true : true;
    }
    this.confirmationDialogService.isSkip=false;
    return true;
  }
}

@Injectable({ providedIn: 'root' })
export class AuthguardService implements CanActivate {

  constructor(private router: Router, private httpService: HttpService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let access = route.data["access"] as Array<string>;
    if (access && access[0]) {
      var tabInfo = this.httpService.getAppInfo(Number(access[0]));
      if (tabInfo.show || tabInfo.isReadonly) {
        return true;
      }
    }

    this.router.navigate(['/auth/login']);
    return false;
  }

}

@Injectable({ providedIn: 'root' })
export class RedirectSystemSettingGuard implements CanActivate {

  constructor(private router: Router, private httpService: HttpService,private confirmationDialogService: ConfirmationDialogService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let access = route.data["access"] as Array<string>;
    this.confirmationDialogService.isSkip=true;
    if (access && access[0] && access[1]) {
      var tabInfo1 = this.httpService.getAppInfo(Number(access[0]));
      var tabInfo2 = this.httpService.getAppInfo(Number(access[1]));
      if (tabInfo1.show || tabInfo1.isReadonly) {
        this.router.navigate(['/system-settings/options']);
        return true;
      }
      else if (tabInfo2.show || tabInfo2.isReadonly) {
        this.router.navigate(['/system-settings/dashboard']);
        return true;
      }
      else {
        this.router.navigate(['/system-settings/groups']);
        return true;
      }
    }

    this.router.navigate(['/auth/login']);
    return false;
  }

}
@Injectable({ providedIn: 'root' })
export class RedirectCaseGuard implements CanActivate {

  constructor(private router: Router, private httpService: HttpService,private confirmationDialogService: ConfirmationDialogService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.confirmationDialogService.isSkip=true;
    this.router.navigate(['/case/list']);
    return true;
  }

}

export interface FormComponent {
  form: FormGroup;
  duelForm: FormGroup;
}
